<template>
    <section id="form_section">
        <div class="container">
            <div v-if="show_error" class="alert-danger mb-12">
                <p>Будь ласка, перевірте обов'язкові поля!</p>
            </div>
            <div class="head_row">
                <div class="text-column">
                    <h1 class="title">Система шинопроводу</h1>
                    <p class="subtitle">Опитувальний лист для замовлення</p>
                </div>
                <a href="#docs" v-on:click="modal_docs = true" class="btn-download">
                    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path id="download-icon" d="M9.5 5H11.5V7H9.5V5ZM9.5 9H11.5V15H9.5V9ZM10.5 0C4.98 0 0.5 4.48 0.5 10C0.5 15.52 4.98 20 10.5 20C16.02 20 20.5 15.52 20.5 10C20.5 4.48 16.02 0 10.5 0ZM10.5 18C6.09 18 2.5 14.41 2.5 10C2.5 5.59 6.09 2 10.5 2C14.91 2 18.5 5.59 18.5 10C18.5 14.41 14.91 18 10.5 18Z" fill="#6C757D"/>
                    </svg>
                    Тех. інформація
                </a>
            </div>

            <div class="form_row_group_item mt-8">
                <div class="flex-group customer_info">
                    <div class="flex_form">
                        <p class="form_subtitle">Дані про замовника:</p>
                        <div class="flex-row">
                            <div class="form_grid">
                                <div class="form_group">
                                    <label class="form_label">Організація*</label>
                                    <input class="form_input" :class="{ 'border-danger': errors.org_name }" v-model="formData.org_name" type="text" placeholder="Назва" />
                                    <p class="error_text" v-if="errors.org_name">Обов'язкове поле</p>
                                </div>
                                <div class="form_group">
                                    <label class="form_label">Контактна особа*</label>
                                    <input class="form_input" :class="{ 'border-danger': errors.name }" v-model="formData.name" type="text" placeholder="ПІБ" />
                                    <p class="error_text" v-if="errors.name">Обов'язкове поле</p>
                                </div>
                            </div>
                            <div class="form_grid">
                                <div class="form_group">
                                    <label class="form_label">Номер телефону *</label>
                                    <input class="form_input" :class="{ 'border-danger': errors.phone }" @input="acceptNumber" v-model="formData.phone" type="text" placeholder="+380" />
                                    <p class="error_text" v-if="errors.phone">Обов'язкове поле</p>
                                </div>
                                <div class="form_group">
                                    <label class="form_label">Електронна пошта *</label>
                                    <input class="form_input" :class="{ 'border-danger': errors.email }" v-model="formData.email" type="text" placeholder="Email" />
                                    <p class="error_text" v-if="errors.email">Обов'язкове поле</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flex_form">
                        <p class="form_subtitle">Об'єкт:</p>
                        <div class="flex-row">
                            <div class="form_group mr-9">
                                <label class="form_label">Найменування та адреса*</label>
                                <textarea  :class="{ 'border-danger': errors.address }" v-model="formData.address" class="form_input form_textarea" rows="5" placeholder="Найменування та адреса"></textarea>
                                <p class="error_text" v-if="errors.address">Обов'язкове поле</p>
                            </div>
                            <div class="form_group flex_centered">
                                <img src="/img/busbar.png" class="trans_img" width="170" height="170" alt="image">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mt-8 main_content">
                    <p class="form_main_subtitle mb-5">Технічні параметри шинопроводу</p>
                    <div class="select_grid">
                        <div class="form_grid">
                            <div class="form_group mb-12">
                                <label class="form_label mb-12" :class="{ 'error_text': errors.power_a }">Номінальний струм, А*</label>
                                <div class="input_group max-width-radio mobile_selects">
                                    <div>
                                        <label class="form_label mb-16">
                                            <input v-model="formData.power_a" value="25" type="checkbox" class="form_radio">
                                            <span class="selected_value weight-400">25</span>
                                        </label>
                                        <label class="form_label mb-16">
                                            <input v-model="formData.power_a" value="32" type="checkbox" class="form_radio">
                                            <span class="selected_value weight-400">32</span>
                                        </label>
                                        <label class="form_label mb-16">
                                            <input v-model="formData.power_a" value="40" type="checkbox" class="form_radio">
                                            <span class="selected_value weight-400">40</span>
                                        </label>
                                        <label class="form_label mb-16">
                                            <input v-model="formData.power_a" value="50" type="checkbox" class="form_radio">
                                            <span class="selected_value weight-400">50</span>
                                        </label>
                                        <label class="form_label mb-16">
                                            <input v-model="formData.power_a" value="64" type="checkbox" class="form_radio">
                                            <span class="selected_value weight-400">64</span>
                                        </label>
                                        <label class="form_label mb-16">
                                            <input v-model="formData.power_a" value="80" type="checkbox" class="form_radio">
                                            <span class="selected_value weight-400">80</span>
                                        </label>
                                        <label class="form_label mb-16">
                                            <input v-model="formData.power_a" value="100" type="checkbox" class="form_radio">
                                            <span class="selected_value weight-400">100</span>
                                        </label>
                                    </div>
                                    <div>
                                        <label class="form_label mb-16">
                                            <input v-model="formData.power_a" value="160" type="checkbox" class="form_radio">
                                            <span class="selected_value weight-400">160</span>
                                        </label>
                                        <label class="form_label mb-16">
                                            <input v-model="formData.power_a" value="250" type="checkbox" class="form_radio">
                                            <span class="selected_value weight-400">250</span>
                                        </label>
                                        <label class="form_label mb-16">
                                            <input v-model="formData.power_a" value="400" type="checkbox" class="form_radio">
                                            <span class="selected_value weight-400">400</span>
                                        </label>
                                        <label class="form_label mb-16">
                                            <input v-model="formData.power_a" value="630" type="checkbox" class="form_radio">
                                            <span class="selected_value weight-400">630</span>
                                        </label>
                                        <label class="form_label mb-16">
                                            <input v-model="formData.power_a" value="800" type="checkbox" class="form_radio">
                                            <span class="selected_value weight-400">800</span>
                                        </label>
                                        <label class="form_label mb-16">
                                            <input v-model="formData.power_a" value="1000" type="checkbox" class="form_radio">
                                            <span class="selected_value weight-400">1000</span>
                                        </label>
                                        <label class="form_label mb-16">
                                            <input v-model="formData.power_a" value="1250" type="checkbox" class="form_radio">
                                            <span class="selected_value weight-400">1250</span>
                                        </label>
                                    </div>
                                    <div>
                                        <label class="form_label mb-16">
                                            <input v-model="formData.power_a" value="1600" type="checkbox" class="form_radio">
                                            <span class="selected_value weight-400">1600</span>
                                        </label>
                                        <label class="form_label mb-16">
                                            <input v-model="formData.power_a" value="2000" type="checkbox" class="form_radio">
                                            <span class="selected_value weight-400">2000</span>
                                        </label>
                                        <label class="form_label mb-16">
                                            <input v-model="formData.power_a" value="2500" type="checkbox" class="form_radio">
                                            <span class="selected_value weight-400">2500</span>
                                        </label>
                                        <label class="form_label mb-16">
                                            <input v-model="formData.power_a" value="3200" type="checkbox" class="form_radio">
                                            <span class="selected_value weight-400">3200</span>
                                        </label>
                                        <label class="form_label mb-16">
                                            <input v-model="formData.power_a" value="4000" type="checkbox" class="form_radio">
                                            <span class="selected_value weight-400">4000</span>
                                        </label>
                                        <label class="form_label mb-16">
                                            <input v-model="formData.power_a" value="5000" type="checkbox" class="form_radio">
                                            <span class="selected_value weight-400">5000</span>
                                        </label>
                                        <label class="form_label mb-16">
                                            <input v-model="formData.power_a" value="6300" type="checkbox" class="form_radio">
                                            <span class="selected_value weight-400">6300</span>
                                        </label>
                                    </div>
                                </div>
                                
                            </div>

                            <div class="form_group mb-12 hidden">
                                <label class="form_label mb-12">Матеріал провідника*</label>
                                <div class="input_group max-width-radio flex-start">
                                    <label class="form_label">
                                        <input v-model="formData.conductor_material" value="Al" type="radio" class="form_radio">
                                        <span class="selected_value weight-400">Al</span>
                                    </label>
                                    <label class="form_label">
                                        <input v-model="formData.conductor_material" value="Cu" type="radio" class="form_radio">
                                        <span class="selected_value weight-400">Cu</span>
                                    </label>
                                </div>
                            </div>

                            <div class="form_grid mb-12 hidden">
                                <div class="form_group">
                                    <label class="form_label mb-12">Виконання шинопроводу</label>
                                    <div class="input_group">
                                        <label class="form_label">
                                            <input v-model="formData.execution.select" value="3P+N+PE" type="radio" class="form_radio">
                                            <span class="selected_value weight-400">3P+N+PE</span>
                                        </label>
                                    </div>
                                </div>

                                <div class="form_group">
                                    <div class="input_group">
                                        <input v-model="formData.execution.select" value="custom" type="radio" class="form_radio">
                                        <input :class="{ 'border-danger': errors.execution }" v-model="formData.execution.custom.value" class="form_input" type="text" placeholder="Інший варіант" />
                                        
                                    </div>
                                    <p class="error_text" v-if="errors.execution">Обов'язкове поле</p>
                                </div>
                            </div>
                        </div>
                        <div class="form_grid to_hide">
                            <div class="form_group mb-12">
                                <label class="form_label mb-12">Матеріал провідника*</label>
                                <div class="input_group max-width-radio flex-start">
                                    <label class="form_label">
                                        <input v-model="formData.conductor_material" value="Al" type="radio" class="form_radio">
                                        <span class="selected_value weight-400">Al</span>
                                    </label>
                                    <label class="form_label">
                                        <input v-model="formData.conductor_material" value="Cu" type="radio" class="form_radio">
                                        <span class="selected_value weight-400">Cu</span>
                                    </label>
                                </div>
                            </div>

                            <div class="form_grid mb-12">
                                <div class="form_group">
                                    <label class="form_label mb-12">Виконання шинопроводу</label>
                                    <div class="input_group">
                                        <label class="form_label">
                                            <input v-model="formData.execution.select" value="3P+N+PE" type="radio" class="form_radio">
                                            <span class="selected_value weight-400">3P+N+PE</span>
                                        </label>
                                    </div>
                                </div>

                                <div class="form_group">
                                    <div class="input_group">
                                        <input v-model="formData.execution.select" value="custom" type="radio" class="form_radio">
                                        <input :class="{ 'border-danger': errors.execution }" v-model="formData.execution.custom.value" class="form_input" type="text" placeholder="Інший варіант" />
                                        
                                    </div>
                                    <p class="error_text" v-if="errors.execution">Обов'язкове поле</p>
                                </div>
                            </div>

                            <div class="form_group mb-12">
                                <label class="form_label mb-12">Ступінь захисту</label>
                                <div class="input_group max-width-radio mobile_selects">
                                    <label class="form_label">
                                        <input v-model="formData.protection_degree" value="IP55" type="radio" class="form_radio">
                                        <span class="selected_value weight-400">IP55</span>
                                    </label>
                                    <label class="form_label">
                                        <input v-model="formData.protection_degree" value="IP66" type="radio" class="form_radio">
                                        <span class="selected_value weight-400">IP66</span>
                                    </label>
                                    <label class="form_label">
                                        <input v-model="formData.protection_degree" value="IP68" type="radio" class="form_radio">
                                        <span class="selected_value weight-400">IP68</span>
                                    </label>
                                </div>
                            </div>

                        </div>
                        <div class="form_grid">
                            <div class="form_group mb-12 hidden">
                                <label class="form_label mb-12">Ступінь захисту</label>
                                <div class="input_group max-width-radio mobile_selects">
                                    <label class="form_label">
                                        <input v-model="formData.protection_degree" value="IP55" type="radio" class="form_radio">
                                        <span class="selected_value weight-400">IP55</span>
                                    </label>
                                    <label class="form_label">
                                        <input v-model="formData.protection_degree" value="IP66" type="radio" class="form_radio">
                                        <span class="selected_value weight-400">IP66</span>
                                    </label>
                                    <label class="form_label">
                                        <input v-model="formData.protection_degree" value="IP68" type="radio" class="form_radio">
                                        <span class="selected_value weight-400">IP68</span>
                                    </label>
                                </div>
                            </div>
                            <div class="form_group mb-12">
                                <label class="form_label mb-12">Тип шинопроводу</label>
                                <div class="input_group mobile_selects busbar_type_container">
                                    <div>
                                        <label class="form_label mb-16">
                                            <input v-model="formData.type" value="Шинний міст: трансформатор - щит" type="checkbox" class="form_radio">
                                            <span class="selected_value max-width-radio weight-400">Шинний міст: трансформатор - щит</span>
                                        </label>
                                        <label class="form_label mb-16">
                                            <input v-model="formData.type" value="Шинний міст: щит - щит" type="checkbox" class="form_radio">
                                            <span class="selected_value max-width-radio weight-400">Шинний міст: щит - щит</span>
                                        </label>
                                        <label class="form_label mb-16">
                                            <input v-model="formData.type" value="Шинний міст: генератор - щит" type="checkbox" class="form_radio">
                                            <span class="selected_value max-width-radio weight-400">Шинний міст: генератор - щит</span>
                                        </label>
                                        <label class="form_label mb-16">
                                            <input v-model="formData.type" value="Шинопровід розподільчий з коробками відбору потужності" type="checkbox" class="form_radio">
                                            <span class="selected_value max-width-radio weight-400">Шинопровід розподільчий з коробками відбору потужності</span>
                                        </label>
                                        <label class="form_label mb-16">
                                            <input v-model="formData.type" value="Шинопровід для освітлення" type="checkbox" class="form_radio">
                                            <span class="selected_value max-width-radio weight-400">Шинопровід для освітлення</span>
                                        </label>
                                        <label class="form_label mb-16">
                                            <input v-model="formData.type" value="Шинопровід для паркінгу та автомобільних зарядних станцій" type="checkbox" class="form_radio">
                                            <span class="selected_value max-width-radio weight-400">Шинопровід для паркінгу та автомобільних зарядних станцій</span>
                                        </label>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mb-12 add_docs_container mt-8">
                    <label class="form_label">Завантажити проектну документацію</label>
                    <a class="btn-files" v-on:click="docmodal = true">
                        <svg width="11" height="22" viewBox="0 0 11 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.5 5V16.5C9.5 18.71 7.71 20.5 5.5 20.5C3.29 20.5 1.5 18.71 1.5 16.5V4C1.5 2.62 2.62 1.5 4 1.5C5.38 1.5 6.5 2.62 6.5 4V14.5C6.5 15.05 6.05 15.5 5.5 15.5C4.95 15.5 4.5 15.05 4.5 14.5V5H3V14.5C3 15.88 4.12 17 5.5 17C6.88 17 8 15.88 8 14.5V4C8 1.79 6.21 0 4 0C1.79 0 0 1.79 0 4V16.5C0 19.54 2.46 22 5.5 22C8.54 22 11 19.54 11 16.5V5H9.5Z" fill="#356EEF"/>
                        </svg>
                        <span>Додати документи</span>
                    </a>
                </div>
                <span class="added_files_count" v-on:click="docmodal = true" v-if="filelist.length">Додано файлів ({{ filelist.length }})</span>

                <div class="flex-row additional_container">
                    <div class="form_group">
                        <label class="form_label">Додаткова інформація</label>
                        <textarea v-model="formData.additional_information" class="form_input form_textarea additional_text" rows="5" placeholder="Додаткова інформація"></textarea>
                        <a class="btn-submit" v-on:click="submit()">
                            <span v-if="!payload">Відправити</span>
                            <span v-if="payload">Зачекайте..</span>
                        </a>
                    </div>
                    <div class="form_group"></div>
                </div>
            </div>
        </div>

        <div class="overlay" v-if="modal || docmodal || modal_docs" v-on:click="() => {modal = false; docmodal = false; modal_docs = false;}"></div>
        <div class="modal" v-if="modal">
            <a class="close_btn" v-on:click="modal = false">
                <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14.5 1.91L13.09 0.5L7.5 6.09L1.91 0.5L0.5 1.91L6.09 7.5L0.5 13.09L1.91 14.5L7.5 8.91L13.09 14.5L14.5 13.09L8.91 7.5L14.5 1.91Z" fill="#356EEF"/>
                </svg>
            </a>
            <div class="modal_form_content">
                <p class="modal_title" style="text-align: center;">Заявка №{{ modal_id }} від {{ modal_date }}</p>
                <p class="modal_text">Ваша Заявка на шинопровід зареєстрована та прийнята, найближчим часом наш менеджер з Вами зв’яжеться. </p>
                <p class="modal_text">Для зручності цю заявку в форматі pdf надіслано Вам на електронну пошту, а також можете переглянути її <a :href="modal_link" target="_blank" class="modal_link">за посиланням</a> </p>
                <a class="modal_btn" style="margin-top: 20px;" v-on:click="modal = false"><p>ОК</p></a>
            </div>
        </div>
        <div class="modal docmodal" v-if="docmodal">
            <div class="doc_modal_form_container">
                <div class="modal_header">
                    <p class="modal_header_title">Прикріпити документ</p>
                    <svg id="close_docmodal" v-on:click="docmodal = false" width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14 2.26151L12.59 0.709961L7 6.86112L1.41 0.709961L0 2.26151L5.59 8.41266L0 14.5638L1.41 16.1154L7 9.96421L12.59 16.1154L14 14.5638L8.41 8.41266L14 2.26151Z" fill="#356EEF"/>
                    </svg>
                </div>
                <div class="doc_modal_form_content" @dragover="dragover" @dragleave="dragleave" @drop="drop">
                    <svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19.35 6.04C18.67 2.59 15.64 0 12 0C9.11 0 6.6 1.64 5.35 4.04C2.34 4.36 0 6.91 0 10C0 13.31 2.69 16 6 16H19C21.76 16 24 13.76 24 11C24 8.36 21.95 6.22 19.35 6.04ZM14 9V13H10V9H7L12 4L17 9H14Z" fill="#356EEF"/>
                    </svg>


                    <div class="file_modal_container">
                        <input type="file" 
                            accept="application/pdf,image/x-dwg,application/acad,image/vnd.dwg,image/x-dxf,drawing/x-dwf,application/octet-stream,image/jpeg,image/png,application/vnd.rar,application/x-rar-compressed,application/zip,application/x-zip-compressed,multipart/x-zip,application/msword,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.dwg"
                            @change="onChange"
                            ref="file"
                            style="display: none;"
                            multiple
                        >
                        <a class="modal_btn_link" @click="$refs.file.click()"><p>Натисніть щоб прикріпити файли до заявки</p></a>

                        <span class="text_secondary">Формат: pdf, dwg, rvt, jpeg, png, rar, zip, cdw, docx, xlsx
                            Загальний розмір усіх доданих файлів до 25 Мб. 
                            Якщо є потреба додати більше файлів чи файлів більшого розміру, це буде вирішено після зв’зку із нашим менеджером </span>
                        
                        <p class="modal_text">або</p>
                        <p class="modal_text">Додайте посилання на гугл диск</p>
                        <div class="modal_input_container">
                            <svg class="link_ico" width="24" height="12" viewBox="0 0 24 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.1 12H6C4.34 12 2.925 11.415 1.755 10.245C0.585 9.075 0 7.66 0 6C0 4.34 0.585 2.925 1.755 1.755C2.925 0.585 4.34 0 6 0H11.1V1.8H6C4.84 1.8 3.85 2.21 3.03 3.03C2.21 3.85 1.8 4.84 1.8 6C1.8 7.16 2.21 8.15 3.03 8.97C3.85 9.79 4.84 10.2 6 10.2H11.1V12ZM7.35 6.9V5.1H16.65V6.9H7.35ZM12.9 12V10.2H18C19.16 10.2 20.15 9.79 20.97 8.97C21.79 8.15 22.2 7.16 22.2 6C22.2 4.84 21.79 3.85 20.97 3.03C20.15 2.21 19.16 1.8 18 1.8H12.9V0H18C19.66 0 21.075 0.585 22.245 1.755C23.415 2.925 24 4.34 24 6C24 7.66 23.415 9.075 22.245 10.245C21.075 11.415 19.66 12 18 12H12.9Z" fill="#356EEF"/>
                            </svg>

                            <input type="text" class="google_drive_link noselect" :class="{ 'border-danger': googleDriveLinkError }" v-on:input="addDriveLink" v-model="formData.google_drive_link">

                            <svg class="close_ico" v-if="formData.google_drive_link" v-on:click="() => {formData.google_drive_link = null; googleDriveLinkError = false;}" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="#6C757D"/>
                            </svg>
                        </div>
                    </div>
                </div>

                <div class="added_files_header" v-if="filelist.length">
                    <span class="added_files">Додані  файли</span>
                </div>
                <ul class="filelist" v-if="filelist.length">
                    <li class="filelist_item" v-for="(file, i) in filelist" :key="`file_${i}`">
                        <div class="file_item">
                            <svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2.5 0C1.4 0 0.51 0.9 0.51 2L0.5 18C0.5 19.1 1.39 20 2.49 20H14.5C15.6 20 16.5 19.1 16.5 18V6L10.5 0H2.5ZM9.5 7V1.5L15 7H9.5Z" fill="#356EEF"/>
                            </svg>

                            <div class="file_item_container">
                                <span class="file_name">{{ file.name }} ({{ formatBytes(file.size) }})</span>
                                <a @click="remove(filelist.indexOf(file))" class="remove_file_btn" title="Remove file">
                                    <svg width="15" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1.5 16C1.5 17.1 2.4 18 3.5 18H11.5C12.6 18 13.5 17.1 13.5 16V4H1.5V16ZM14.5 1H11L10 0H5L4 1H0.5V3H14.5V1Z" fill="#4C5567"/>
                                    </svg>
                                </a>
                            </div>
                        </div>
                    </li>
                </ul>
                <a class="modal_btn" v-if="filelist.length" @click="$refs.file.click()"><p>Додати файл</p></a>
                <a class="modal_btn" style="margin-top: 15px;" v-if="formData.google_drive_link && !filelist.length && !googleDriveLinkError" v-on:click="docmodal = false"><p>Додати посилання</p></a>
            </div>
        </div>

        <div class="modal docs_modal" v-if="modal_docs">
            <div class="modal_container">
                <div class="docs_modal_header">
                    <div class="nosense"></div>
                    <p class="modal_header_title">Документація</p>
                    <svg id="close_modal" v-on:click="modal_docs = false" width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14 2.26151L12.59 0.709961L7 6.86112L1.41 0.709961L0 2.26151L5.59 8.41266L0 14.5638L1.41 16.1154L7 9.96421L12.59 16.1154L14 14.5638L8.41 8.41266L14 2.26151Z" fill="#356EEF"/>
                    </svg>
                </div>
                <div class="modal_content">
                    <ul class="filelist docs_filelist">
                        <template v-for="(doc, i) in docs" :key="`file_${i}`">
                            <li class="filelist_item">
                                <a :href="doc.url" target="_blank" class="file_item">
                                    <svg style="margin-top: 5px;" width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M2.5 0C1.4 0 0.51 0.9 0.51 2L0.5 18C0.5 19.1 1.39 20 2.49 20H14.5C15.6 20 16.5 19.1 16.5 18V6L10.5 0H2.5ZM9.5 7V1.5L15 7H9.5Z" fill="#356EEF"/>
                                    </svg>

                                    <div class="file_item_container">
                                        <span class="file_name">{{ doc.title }} ({{ doc.size }})</span>
                                    </div>
                                    <div class="download_ico">
                                        <svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M14 6H10V0H4V6H0L7 13L14 6ZM0 15V17H14V15H0Z" fill="#356EEF"/>
                                        </svg>
                                    </div>
                                </a>
                            </li>
                        </template>
                    </ul>
                </div>
            </div>
        </div>

    </section>
</template>

<script>
import PreloadForm from "@/Components/PreloadForm";
import Fieldset from 'primevue/fieldset';
import Dropdown from 'primevue/dropdown';
import RadioButton from 'primevue/radiobutton';
import InputNumber from 'primevue/inputnumber';
import Checkbox from 'primevue/checkbox';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import ColumnGroup from "primevue/columngroup";
import Button from "primevue/button";
import Dialog from "primevue/dialog";
import Row from "primevue/row";
import axios from "axios";
import CommonLayout from "@/Layouts/CommonLayout";
import Label from '../Jetstream/Label.vue';
import Input from '../Jetstream/Input.vue';
import FormHelper from './mixins/form_helper';


export default {
    props: {
        file: {
            type: String,
            required: false,
        },
        docs: {
            type: Object,
            required: false,
        },
    },

    components: {
        PreloadForm,
        Fieldset,
        Dropdown,
        RadioButton,
        InputNumber,
        Checkbox,
        TabView,
        TabPanel,
        DataTable,
        Column,
        Button,
        Dialog,
        ColumnGroup,
        Row,
        Input,
        Label
    },
    layout: CommonLayout,
    delimiters: ['${', '}'],
    mixins: [FormHelper],
    data() {
        return {
            modal: false,
            docmodal: false,
            modal_docs: false,
            payload: false,
            googleDriveLinkError: false,
            filelist: [],
            formData: {
                org_name: null,
                phone: null,
                name: null,
                email: null,
                address: null,
                power_a: [],
                conductor_material: 'Al',
                execution: {
                    select: '3P+N+PE',
                    custom: {
                        value: null,
                    },
                },
                protection_degree: 'IP55',
                type: [],
                additional_information: null,
                google_drive_link: null,
            },
            sendData: null,
            is_toggle: false,
            show_error: false,
            errors: {
                org_name: false,
                phone: false,
                name: false,
                email: false,
                address: false,
                execution: false,
                power_a: false,
            },
            modal_id: null,
            modal_date: null,
            modal_link: null,
        }
    },

    watch: {
        'formData': {
            handler: function() {
                this.validateFields();
            },
            deep: true
        },

        'formData.execution.select': {
            handler: function(newValue, oldValue) {
                if (newValue && newValue !== 'custom') {
                    this.formData.execution.custom.value = null;
                }
            },
        },
        'formData.execution.custom.value': {
            handler: function(newValue, oldValue) {
                if (newValue && newValue !== oldValue) {
                    this.formData.execution.select = 'custom';
                }
            },
        },
        
    },

    methods: {
        addDriveLink() {
            this.googleDriveLinkError = false;

            if (!this.formData.google_drive_link.includes('://drive.google.com/drive/') && !this.formData.google_drive_link.includes('://drive.google.com/file/')) {
                this.googleDriveLinkError = true;
            }

            if (!this.formData.google_drive_link) {
                this.googleDriveLinkError = false;
            }
        },
        acceptNumber() {
            var x = this.formData.phone.replace(/\D/g, '').replace('380', '').replace('38', '').match(/(\d{0,2})(\d{0,3})(\d{0,4})/);

            this.formData.phone = !x[2] && x[1] ? '+380' + x[1] : (x[1] ? '+38 (0' + x[1] + ') ' : '+380') + x[2] + (x[3] ? '-' + x[3] : '');
        },

        toggle() {
            this.is_toggle = !this.is_toggle;
            this.$forceUpdate();
        },

        formatBytes(bytes, decimals = 2) {
            if (!+bytes) return '0 Bytes'

            const k = 1024
            const dm = decimals < 0 ? 0 : decimals
            const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

            const i = Math.floor(Math.log(bytes) / Math.log(k))

            return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
        },

        dragover(event) {
            event.preventDefault();
            // Add some visual fluff to show the user can drop its files
            if (!event.currentTarget.classList.contains('bg-drop')) {
                event.currentTarget.classList.add('bg-drop');
            }
        },
        dragleave(event) {
            // Clean up
            event.currentTarget.classList.remove('bg-drop');
        },
        drop(event) {
            event.preventDefault();
            this.$refs.file.files = event.dataTransfer.files;
            this.onChange(); // Trigger the onChange event manually
            // Clean up
            event.currentTarget.classList.remove('bg-drop');
        },

        remove(i) {
            this.filelist.splice(i, 1);
        },

        onChange() {
            if (this.$refs.file.files.length) {
                // if (this.filelist.length <= 10 && this.$refs.file.files.length <= 10 && this.filelist.length + this.$refs.file.files.length <= 10) {
                    let files = this.$refs.file.files;

                    let maxSize = 0;

                    this.filelist.forEach((value, index) => {
                        maxSize += value.size;
                    });

                    for (var i = 0; i < this.$refs.file.files.length; i++) {
                        maxSize += files[i].size;
                        
                        if ((maxSize / 1024 / 1024) <= 25) {
                            this.filelist.push(files[i]);
                        } else {
                            alert('Максимальний розмір усіх доданих файлів - 25MB');

                            return false;
                        }
                    }

                // } else {
                //     alert('Максимальна кількість файлів - 10 шт.');
                // }
            }

            // if (this.filelist.length <= 10 && this.$refs.file.files.length <= 10) {
            //     this.filelist = [...this.$refs.file.files];
            // } else {
            //     alert('Максимальна кількість файлів - 10 шт.');
            // }
        },

        validateFields() {
            this.errors = {
                org_name: false,
                phone: false,
                name: false,
                email: false,
                address: false,
                execution: false,
                power_a: false,
            };

            if (!this.formData.org_name) {
                this.errors.org_name = true;
                return false;
            } else {
                this.errors.org_name = false;
            }
            if (!this.formData.phone) {
                this.errors.phone = true;
                return false;
            } else {
                this.errors.phone = false;
            }
            if (!this.formData.name) {
                this.errors.name = true;
                return false;
            } else {
                this.errors.name = false;
            }
            if (!this.formData.email || !(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.formData.email))) {
                this.errors.email = true;
                return false;
            } else {
                this.errors.email = false;
            }
            if (!this.formData.address) {
                this.errors.address = true;
                return false;
            } else {
                this.errors.address = false;
            }

            if (this.formData.execution.select === 'custom' && !this.formData.execution.custom.value) {
                this.errors.execution = true;
                return false;
            } else {
                this.errors.execution = false;
            }

            if (!this.formData.power_a.length) {
                this.errors.power_a = true;
                return false;
            } else {
                this.errors.power_a = false;
            }

            return true;
        },

        getRequestData() {
            let data = {
                org_name: this.formData.org_name,
                phone: this.formData.phone,
                name: this.formData.name,
                email: this.formData.email,
                address: this.formData.address,
                additional_information: this.formData.additional_information,
                execution: this.formData.execution,
                power_a: this.formData.power_a,
                conductor_material: this.formData.conductor_material,
                protection_degree: this.formData.protection_degree,
                type: this.formData.type,
                files: this.filelist,
                google_drive_link: this.formData.google_drive_link,
            };

            if (this.formData.execution.select == 'custom') {
                data.execution = this.formData.execution.custom.value;
            } else {
                data.execution = this.formData.execution.select;
            }

            if (this.formData.power_a) {
                data.power_a = this.formData.power_a.join();
            }

            if (this.formData.type) {
                data.type = this.formData.type.join();
            }

            if (this.googleDriveLinkError) {
                data.google_drive_link = null;
            }

            return data;
        },

        submit() {
            if (!this.payload) {
                this.show_error = false;
                this.payload = true;

                let isValid = this.validateFields();

                if (isValid) {
                    this.sendData = new FormData();
                    this.collectFormData(this.getRequestData());

                    axios.post(
                        this.route('send.form.busbar'),
                        this.sendData,
                        {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            },
                        }
                    )
                    .then((result) => {
                        this.modal_id = result.data.id;
                        this.modal_date = result.data.created_at;
                        this.modal_link = result.data.file;
                        this.modal = true;
                        this.payload = false;
                    }).catch((error) => {
                        window.scroll(0, 0);
                        this.show_error = true;
                        this.payload = false;
                    })
                } else {
                    window.scroll(0, 0);
                    this.show_error = true;
                    this.payload = false;
                }
            }
        }
    }
};
</script>

<style scoped>
.mt-8 {
    margin-top: 80px;
}
.mt-24 {
    margin-top: 24px;
}
.mr-9 {
    margin-right: 90px;
}
.mb-5 {
    margin-bottom: 50px;
}
.mb-12 {
    margin-bottom: 12px;
}
.mb-16 {
    margin-bottom: 16px;
}
.gap-20 {
    gap: 20px;
}
#form_section {
    max-width: 1296px;
    margin: 0 auto;
}
.container {
    padding: 80px 60px 0 20px;
}
.additional_container {
    margin-top: 60px;
    display: flex;
    justify-content: space-between;
}
.additional_container .form_group {
    width: auto;
}
.select_grid {
    display: flex;
    justify-content: space-between;
    gap: 110px;
}
.btn-download {
    padding: 13px 30px;
    width: 220px;
    height: 51px;
    border: 1px solid #6C757D;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    color: #6C757D;
}
.btn-download:hover {
    background-color: #356EEF;
    color: #fff;
}
.btn-download:hover #download-icon {
    fill: #fff;
}
.btn-download svg{
    margin-right: 15px;
}
.form_row_group {
    display: flex;
    justify-content: space-between;
}
.head_row {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.title {
    /* font-family: 'Helvetica Neue'; */
    font-style: normal;
    font-weight: 700;
    font-size: 36px;
    line-height: 50px;
    color: #000000;

}
.subtitle {
    /* font-family: 'Helvetica Neue'; */
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 30px;
    color: #000000;
}
.flex-row, .flex-group {
    display: flex;
    flex-direction: row;
    gap: 24px;
}
.form_subtitle {
    /* font-family: 'Helvetica Neue'; */
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    color: #000000;
}
.form_main_subtitle {
    /* font-family: 'Helvetica Neue'; */
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 36px;
    color: #000000;

}
.form_label {
    /* font-family: 'Helvetica Neue'; */
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #000000;
    display: flex;
    align-items: center;
    /* cursor: pointer; */
}
.busbar_type_container .form_label {
    align-items: start;
}
.busbar_type_container a {
    text-decoration: underline;
}
.form_label_secondary {
    font-weight: 400;
}
.form_input {
    /* font-family: 'Helvetica Neue'; */
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    padding: 10px 16px;
    background: #FFFFFF;
    border: 1px solid #CED4DA;
    border-radius: 4px;
    max-width: 200px;
    height: 100%;
}
.form_textarea {
    max-width: 100%;
    height: auto;
}
.customer_info .form_input {
    max-width: 100%;
}
.count_input {
    max-width: 55px;
}
.form_input::placeholder {
    color: #6C757D;
}
.form_group {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
}
.form_grid {
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%;
}
.flex_form {
    width: 100%;
}

textarea {
    font-family: 'Helvetica'!important;
}

.block_title {
    /* font-family: 'Helvetica Neue'; */
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 36px;
    color: #000000;
}

.added_files_count {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #356EEF;
    cursor: pointer;
}

.form_select {
  appearance: none;
  background-image: url('/img/caret.svg');
  background-repeat: no-repeat;
  background-position: right 0.7rem top 50%;
  background-size: 0.65rem auto;
}

.form_radio {
    width: 20px;
    height: 20px;
    min-width: 20px;
    cursor: pointer;
}

.form_checkbox {
    width: 18px;
    height: 18px;
    cursor: pointer;
}

.input_group {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 18px;
}

.selected_value {
    margin-left: 18px;
    cursor: pointer;
}

.bg-drop {
    background: aliceblue;
}

.toggle_header {
    display: flex;
    align-items: center;
    height: 55px;
    justify-content: space-between;
    padding: 0 25px 0 25px;
    background: #C8E4FF;
    border: 1px solid #C8E4FF;
    border-radius: 4px;
    cursor: pointer;
}

.cater.active {
    transform: rotate(180deg);
}

.doc_link {
    text-decoration: underline;
}

.toggle_content {
    padding: 25px;
    border: 1px solid #C8E4FF;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
}

.toggle_header.active {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
}

.btn-submit {
    /* font-family: 'Helvetica Neue'; */
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 12px 30px;
    width: 180px;
    height: 49px;
    background: #356EEF;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    color: #FFFFFF;
    cursor: pointer;
    margin-top: 20px;
}

.btn-files {
    width: 234px;
    height: 48px;
    /* font-family: 'Helvetica Neue'; */
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    display: flex;
    justify-content: center;
    gap: 16px;
    align-items: center;
    color: #356EEF;
    border: 1px solid #356EEF;
    border-radius: 4px;
    cursor: pointer;
}

.btn-submit:hover {
    background: #FFF;
    border: 1px solid #356EEF;
    color: #356EEF;
}

.add_docs_container .btn-submit:hover, .btn-files:hover {
    background: #356EEF;
    border: 1px solid #356EEF;
    color: #FFFFFF;
}

.btn-files:hover svg path {
    fill: #fff;
}

.add_docs_container .btn-submit {
    width: 200px;
    margin-top: 0px;
    display: flex;
    gap: 10px;
}

.add_docs_container {
    display: flex;
    flex-direction: column;
    gap: 14px;
    align-items: flex-start;
}

.toggle {
    width: 100%;
}

.toggle_row {
    display: flex;
    gap: 24px;
}

.additional_text {
    width: 416px;
}

.justify_betwen {
    justify-content: space-between;
}

.form_select {
    width: 100%;
}

.border-danger {
    border: 1px solid red!important;
    color: red;
}

.border-danger:focus {
    outline-width: 0;
}

.alert-danger {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 0.75rem 1.25rem;
    color: #721c24;
    border: 1px solid transparent;
    border-radius: 0.25rem;
    background-color: #f8d7da;
    border-color: #f5c6cb;
}

.error_text {
    color: red;
}

.doc_modal_form_container {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.doc_modal_form_content {
    display: flex;
    justify-content: center;
    text-align: center;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    border: 2px dashed #CED4DA;
    border-radius: 24px;
    width: 100%;
    height: 323px;
    margin-top: 30px;
    padding-top: 30px;
    padding-bottom: 30px;
}

.doc_modal_form_content.active {
    flex-direction: revert;
    gap: 16px;
}

.doc_modal_form_content.active .file_modal_container {
    text-align: start;
    justify-content: start;
    align-items: start;
}

.file_modal_container {
    display: flex;
    justify-content: center;
    text-align: center;
    flex-direction: column;
    align-items: center;
    gap: 10px;
}

.modal_header {
    border-bottom: 1px solid #CED4DA;
    width: 100%;
    padding-bottom: 10px;
    position: relative;
}

.modal_content {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #151920;
    margin-top: 14px;
}

.docs_modal_header {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #CED4DA;
    width: 100%;
    padding-bottom: 10px;
    position: relative;
    align-items: center;
}

.docs_modal {
    width: 504px;
}

#close_modal {
    cursor: pointer;
}

#close_docmodal {
    position: absolute;
    right: 0;
    top: 5px;
    cursor: pointer;
}

.modal_text {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    text-align: center;
    color: #1C1C1C;
    margin: 0px;
}

.doc_modal_form_content .text_secondary{
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    text-align: center;
    letter-spacing: 0.05em;
    color: #8E8F96;
    padding: 0px 20px;
}
.added_files{
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    letter-spacing: 0.05em;
    color: #919299;
}

.added_files_header {
    width: 400px;
    display: flex;
    align-items: flex-start;
    margin-top: 16px;
    margin-bottom: 8px;
}

.modal_header_title {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #000000;
}

.modal_title {
    /* font-family: 'Helvetica Neue'; */
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 27px;
    color: #212529;
}
.modal_text {
    /* font-family: 'Helvetica Neue'; */
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #212529;
}
.modal_link {
    /* font-family: 'Helvetica Neue'; */
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #356EEF;
}

.file_name {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    letter-spacing: 0.05em;
    color: #000000;
}

.overlay {
    z-index: 1;
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    cursor: pointer;
    background: rgba(0, 0, 0, 0.45);
}

.modal {
    position: fixed;
    z-index: 101;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    overflow: hidden;
    z-index: 2;
    width: 466px;
    height: auto;
    padding: 30px 30px 30px 30px;
    background: #FFFFFF;
    box-shadow: 0px 8px 36px rgba(0, 0, 0, 0.16);
    border-radius: 15px;
    z-index: 999;
}

.docmodal {
    width: 504px;
}

.modal_btn {
    height: 46px;
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 25px;
    color: #FFFFFF;
    background: #356EEF;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 13px 16px;
    cursor: pointer;
}

.modal_btn_link {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    text-decoration-line: underline;
    color: #1C1C1C;
    cursor: pointer;
}

.close_btn {
    position: absolute;
    right: 20px;
    cursor: pointer;
}

.grid_right .form_label {
    width: 100%;
}

.grid_right .w-auto {
    width: auto!important;
}

.weight-400 {
    font-weight: 400;
}

.max-width {
    max-width: 246px;
}
.max-width-radio {
    max-width: 271px;
    justify-content: space-between;
}
.max-width-radio-init {
    max-width: 238px;
    justify-content: space-between;
}

.flex-start {
    justify-content: start;
    gap: 30px;
}

.flex-betwen {
    display: flex;
    justify-content: space-between;
}

.filelist {
    padding: 0px;
    margin: 0;
    margin-bottom: 24px;
    width: 400px;
    overflow: auto;
    max-height: 200px;
}

.docs_filelist {
    width: 100%;
    max-height: 345px;
}

.filelist li {
    list-style: none;
    display: flex;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 5px;
    width: 100%;
    padding: 13px;
    background: rgba(126, 170, 255, 0.2);
    border-radius: 4px;
}

.filelist li a {
    cursor: pointer;
}

.file_item {
    display: flex;
    gap: 17px;
    width: 100%;
}

.file_item_container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    border-bottom: 2px solid #2F80ED;
    padding-bottom: 5px;
}

.modal_input_container {
    display: flex;
    width: 100%;
    max-width: 400px;
    position: relative;
}

.modal_input_container .link_ico {
    position: absolute;
    left: 20px;
    top: 16px;
}
.modal_input_container .close_ico {
    position: absolute;
    right: 20px;
    top: 16px;
    cursor: pointer;
}

.google_drive_link {
    width: 100%;
    display: block;
    max-width: 400px;
    height: 44px;
    border: 1px solid #CED4DA;
    border-radius: 4px;
    padding-left: 50px;
    padding-right: 40px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 18px;
}

@media (max-width: 1180px) {
    .toggle_row {
        flex-direction: column;
    }
    .additional_text {
        width: 396px;
    }
    .select_grid {
        gap: 50px;
    }
    .head_row {
        flex-direction: column;
        justify-content: start;
        align-items: start;
        gap: 25px;
    }
    .flex-row {
        flex-direction: column!important;
    }
    .title {
        font-size: 30px;
        line-height: 42px;
    }
    .subtitle {
        font-size: 18px;
        line-height: 22px;
    }
    .flex_centered {
        align-items: center;
    }
}

@media (max-width: 980px) {
    .to_hide {
        display: none;
    }
    .form_grid.hidden {
        display: flex!important;
    }
    .form_group.hidden {
        display: flex!important;
    }
}

@media (max-width: 880px) {
    .toggle_content .form_input {
        max-width: 135px;
    }
}

@media (max-width: 780px) {
    .container {
        padding: 50px 1rem 0 1rem;
    }
    .flex-group {
        flex-direction: column;
    }
    .trans_img {
        display: none;
    }
    .toggle_content {
        padding: 20px;
    }
    .toggle_content .select_grid {
        flex-direction: column;
    }
    .toggle_content .input-grid{
        width: 100%;
        flex-direction: column;
        align-items: start;
    }
    .toggle_content .form_input {
        max-width: 100%;
    }
    .main_content .select_grid {
        gap: 0;
        flex-direction: column;
    }
    .busbar-img {
        display: none;
    }
    .form_row_group {
        display: block;
    }
    .add_docs_container {
        flex-direction: column;
    }
    .flex-start {
        gap: 45px;
    }
    .mt-8 {
        margin-top: 60px!important;
    }
    .modal {
        width: 355px;
    }
}

@media (max-width: 480px) {
    .toggle_content {
        padding: 15px;
    }
    .file_name {
        width: 165px;
    }
    .docmodal {
        padding: 20px 22px 20px 22px;
    }
    .doc_modal_form_content {
        margin-top: 0px;
        height: auto;
        padding-top: 20px;
        padding-bottom: 20px;
    }
    .mobile_drop_input {
        max-width: 145px!important;
    }
    .mobile_selects .selected_value {
            margin-left: 5px!important;
    }
    .modal_input_container, .filelist, .added_files_header {
        max-width: 100%;
    }
    .doc_modal_form_content {
        border: none;
    }
    .added_files_header {
        margin-top: 0px;
    }
}

@media (max-width: 390px) {
    .docs_modal {
        width: 330px;
    }
}

</style>
